import { createContext, useContext, useEffect, useState } from 'react';
import Pusher from 'pusher-js';
import { useSelector } from 'react-redux';
import IP from 'src/StoreGlobal/IP';

const PusherContext = createContext(null);
export const PusherProvider = ({ children, cluster = 'ap1', config = {} }) => {
  const token = useSelector((state) => state.auth.token);
  const [pusher, setPusher] = useState(null);
  const [generalChatPusher, setGeneralChatPusher] = useState(null);

  useEffect(() => {
    if (!token) return;

    const pusherInstance = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster,
      authEndpoint: IP + 'notification/pusher/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      },
      ...config
    });

    const generalChatPusherInstance = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster,
      authEndpoint: IP + 'notification/pusher/auth/general-chat',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      },
      ...config
    });

    setPusher(pusherInstance);
    setGeneralChatPusher(generalChatPusherInstance);

    return () => {
      pusherInstance.disconnect();
      generalChatPusherInstance.disconnect();
    };
  }, [token, cluster]);

  return (
    <PusherContext.Provider value={{ pusher, generalChatPusher }}>
      {children}
    </PusherContext.Provider>
  );
};

export const usePusher = () => {
  const context = useContext(PusherContext);
  if (!context) {
    throw new Error('usePusher must be used within a PusherProvider');
  }
  return context;
};